import React, {Component} from 'react';
import '../css/smart-forms.css';
import '../css/smart-addons.css';
import '../css/font-awesome.min.css';
import '../css/slick-modal-min.css';
import '../css/style.css';
import Header from './Header';

class App extends Component {

    render() {
        let pageState = this.props.children.props.route.path;

        return (
            <div>
                <Header
                    pageState={pageState}
                />
                <div>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/